import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class kcbtApiService {

  constructor(private dataService: DataService) { 
  }

  /////////////Dash
  getDashData(year: any, Month: any) {
    return this.dataService.getData('/api/GetDashboard/'+year+'/'+Month, true)
  }

  getGreivanceData(fromDate: any, toDate: any) {
    return this.dataService.getData('/api/Getamenities/'+fromDate+'/'+toDate, true)
  }

  
  ////////////////bus
  getBusAllData(payload) {
    return this.dataService.post('/api/GetAllBus', payload)
  }
  getDestianaionName() {
    return this.dataService.getData('/api/MobileGetAllBusRoute', true)
  }
  getClassDrop() {
    return this.dataService.getData('/api/BusTypeList', true)
  }
  deleteBusDetial(id: any) {
    return this.dataService.delete('/api/BusDataDelete/'+id)
  }

  //////////////////////////// report
  getGrievanceReportAll( data:any) {
    return this.dataService.getData('/api/GetGrievanceReport/'+data.grievanceType+'/'+data.status+'/'+data.fromDate+'/'+data.toDate, true);
  }
  getGrievanceTypeDrop() {
    return this.dataService.getData('/api/GrievanceType' ,true)
  }
  getGrievanceStatusDrop() {
    return this.dataService.getData('/api/GrievanceStatus' ,true)
  }
    getGrievanceCatogeryDrop(p0: (res: any) => void) {
    return this.dataService.getData('/api/GetGrievanCategoryList' ,true)
  }
  NatureOfComplaintsDrop() {
    return this.dataService.getData('/api/NatureofComplients', true)
  }
  InspectionStatusDrop() {
    return this.dataService.getData('/api/InspectionStatus', true)
  }
  getInspectionReportAll(data:any) {
    return this.dataService.getData('/api/GetInspectionReport/'+data.natureofComplient+'/'+data.status+'/'+data.fromDate+'/'+data.toDate, true)
  }

  /////////////////////////
  
  getGrievanAndAdminVal(payload: any) {
    return this.dataService.post('/api/GetGrievance',payload).pipe(map(responce => {
      return responce;
    }));
  }

  saveBusdetail(data: any) {
    return this.dataService.post('/api/listsave', data).pipe(map(response => {
      return response;
    }));
  }

  validateExcelData(Data: any) {
    return this.dataService.post('/api/excelvalidate', Data).pipe(map(response => {
      return response;
    }))
  }

  saveExcelData(Data: any) {
    return this.dataService.post('/api/importSave', Data).pipe(map(response => {
      return response;
    }))
  }

  getGrievansaveList(data: any) {
    return this.dataService.getData('/api/GetGrievanDetails/'+data.CurrentStatusType, true);
  }
  
  getGrievanDataById(referenceno) {
    return this.dataService.getData('/api/GetGrievan/'+referenceno, true);
  }

  getGrievanceDataRefNo(referenceno) {
    return this.dataService.getData('/api/GetamenitiesByRef/'+referenceno, true);
  }


  submitGrievance(data: any) {
    return this.dataService.post('/api/GrievanceSaveAndUpdate', data);
  }

  getLookupRedirect() {
    return this.dataService.getData('/api/lookup/redirect', true);
  }

  updateRedirectValue(data: any) {
    return this.dataService.post('/api/MobileGrievanceBVGSave', data).pipe(map(responce => {
      return responce
    }))
  }

  ////////////xts
  getGrievanXtsList(data: any) {
    return this.dataService.getData('/api/GetGrievanXts/'+ data.CurrentStatusType, true);
  }

  getGrievanXts(id: any) {
    return this.dataService.getData('/api/GetGrievance'+id, true);
  }

  getGrievanAndAdminValXts(id: any) {
    return this.dataService.getData('/api/GetGrievanceXts/'+id, true);
  }
  
  getGrievancebyRefxts(referenceno) {
    return this.dataService.getData('/api/GetGrievanXtsref/'+referenceno, true);
  }

  updateGrievance (data: any) {
    return this.dataService.post('/api/GrievanceSaveAndUpdate', data);
  }

  ////////inspection
  getInspection() {
    return this.dataService.getData('/api/GetInspection', true)
  }

  getInspecionData(data: any) {
    return this.dataService.post('/api/GetInspection',data).pipe(map(response => {
      return response
    }))
  }

  getInspectionDatas(FromDate, ToDate, NatureOfComplaint, UrgencyOfComplaint) {
    return this.dataService.getData('/api/GetInspection/'+FromDate+'/'+ToDate+'/'+NatureOfComplaint+'/'+UrgencyOfComplaint, true)
    
  }
  getStatusDrop(id) {
    return this.dataService.getData('/api/EnnumType/'+id, true)
  }

  editInspection(data) {
    return this.dataService.post('/api/InspectionEventSave',data).pipe(map(responce => {
      return responce
    }))
  }
  redirectInspection(data) {
    return this.dataService.post('/api/InspectionEventRedirect',data).pipe(map(responce => {
      return responce
    }))
  }
  ////////FeedBack

  getFeedback(fromDate: any, toDate: any) {
    return this.dataService.getData('/api/GetFeedBack/'+fromDate+'/'+toDate, true)
  }
  
  //////////BVG
  getBVG() {
    return this.dataService.getData('/api/GetGrievanceList', true)
  }
  getBvgById(payload: any) {
    return this.dataService.post('/api/GetGrievance',payload).pipe(map(responce => {
      return responce
    }));
  }
  redirectDrop() {
    return this.dataService.getData('/api/lookup/redirect', true);
  }

  ///pdf Upload

  uploadPdfAttachment(data: any) {
    return this.dataService.post('/api/PDFAttachment', data)
  }

  getUploadedPdf(id: number) {
    return this.dataService.getData('/api/GetPDFAttachmentbyId/'+id, true)
  }

  dropDesination() {
    return this.dataService.getData('/api/PDFType', true)
  }

  getParking() {
    return this.dataService.getData('/api/GetParkingDetails', true)
  }

  updateLocContent(id: any, data: any) {
    return this.dataService.post('/api/LocContent/'+id, data)
  }


  /////////
  logoutApi() {
    return this.dataService.post('/api/user/logout', true)
  }
}

